import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import VueGtag from "vue-gtag";
import { Tooltip } from 'bootstrap'

import "@/assets/vendor/fonts/remixicon/remixicon.css";

// Menu waves
import "@/assets/vendor/libs/node-waves/node-waves.css";

// Core CSS
import "@/assets/vendor/css/rtl/core.css";
import "@/assets/vendor/css/rtl/theme-default.css";
import "@/assets/css/demo.css";

import "@/assets/vendor/js/helpers.js";
// import "@/assets/js/config.js";

document.documentElement.setAttribute("lang", "en");
document.documentElement.setAttribute("class", "light-style layout-navbar-fixed layout-menu-fixed layout-compact");
document.documentElement.setAttribute("dir", "ltr");
document.documentElement.setAttribute("data-theme", "theme-default");
document.documentElement.setAttribute("data-template", "vertical-menu-template-no-customizer-starter");
document.documentElement.setAttribute("data-style", "light");

import "@/assets/vendor/js/bootstrap.js";
import "@/assets/vendor/js/menu.js";

// import "@/assets/js/main.js";

import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';

// import '@/assets/vendor/libs/datatables-bs5/datatables.bootstrap5.css';
// import '@/assets/vendor/libs/datatables-responsive-bs5/responsive.bootstrap5.css';

// Création et montage de l'application
const app = createApp(App);

// Load router
app.use(router);
app.use(store);

router.beforeEach((to, from, next) => {
  // 🔥 Supprimer tous les tooltips existants
  const activeTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  activeTooltips.forEach(el => {
    const instance = Tooltip.getInstance(el)
    if (instance) {
      instance.dispose()
    }
  })
  next()
})

app.use(VueGtag, {
	config: { id: "AW-16956522772" }, // Remplacez par votre ID Google Analytics 4
}, router);

// app.directive('tooltip', tooltip)

app.mount("#app");